import type { LocationQueryValue } from 'vue-router'

type QueryValue = LocationQueryValue | LocationQueryValue[] | undefined

/**
 * One query param read as a string — a repeated key, a bare `?flag` and a missing key
 * all come out as `null`. Ids stay strings on purpose: that is what the backend echoes
 * back in a select's options, and converting would stop the option from matching.
 */
export function routeQueryString(value: QueryValue): string | null {
  if (typeof value !== 'string' || value === '') return null

  return value
}

/**
 * One query param read as a number — `?typeId=1` → `1`.
 *
 * A query param is a string, an array of strings (repeated key), `null` (bare `?flag`)
 * or missing, and every one of those means "no value" here. Returns `null` rather than
 * `NaN` so the result drops straight into a nullable form field.
 */
export function routeQueryNumber(value: QueryValue): number | null {
  if (typeof value !== 'string' || value === '') return null

  const parsed = Number(value)

  return Number.isFinite(parsed) ? parsed : null
}
